import axios from "axios";

const TOKEN_KEY = "ddd_customer_token";
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export function getCustomerToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function setCustomerToken(t) {
  if (t) localStorage.setItem(TOKEN_KEY, t);
  else localStorage.removeItem(TOKEN_KEY);
}

export function customerAuthHeaders() {
  const t = getCustomerToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
}

export async function lookupCustomer(email) {
  const e = (email || "").trim();
  if (!e || !/^\S+@\S+\.\S+$/.test(e)) return { exists: false };
  const res = await axios.get(`${API}/customer/lookup`, { params: { email: e } });
  return res.data || { exists: false };
}

export async function registerCustomer({ email, password, name, phone }) {
  const res = await axios.post(`${API}/customer/register`, { email, password, name, phone });
  setCustomerToken(res.data.token);
  return res.data;
}

export async function loginCustomer({ email, password }) {
  const res = await axios.post(`${API}/customer/login`, { email, password });
  setCustomerToken(res.data.token);
  return res.data;
}

export async function fetchMe() {
  const res = await axios.get(`${API}/customer/me`, { headers: customerAuthHeaders() });
  return res.data;
}

export async function fetchMyAppointments() {
  const res = await axios.get(`${API}/customer/appointments`, {
    headers: customerAuthHeaders(),
  });
  return res.data;
}

export async function cancelMyAppointment(id) {
  return axios.post(
    `${API}/customer/appointments/${id}/cancel`,
    {},
    { headers: customerAuthHeaders() },
  );
}

export async function rescheduleMyAppointment(id, isoLocal) {
  return axios.post(
    `${API}/customer/appointments/${id}/reschedule`,
    { start_at: isoLocal },
    { headers: customerAuthHeaders() },
  );
}

export function logoutCustomer() {
  setCustomerToken(null);
}
